import { useState } from 'react';

/**
 * Numéro qui change à chaque nouvelle donnée (rechargement d'un useLoader) : la version des blocs qui chargent leur
 * propre page (ex. l'historique du statut d'une feuille, rechargé après une signature). État ajusté pendant le rendu,
 * comme useListControls pour resetKey
 */
export function useDataVersion(data: unknown): number {
  const [state, setState] = useState({ data, version: 0 });
  if (state.data !== data) {
    const next = { data, version: state.version + 1 };
    setState(next);
    return next.version;
  }
  return state.version;
}
